const JOBAPPLICATION_MAP = {
  'efcregistrationwidget.jobapplication.captureemail.title': 'captureemail.title',
  'efcregistrationwidget.jobapplication.captureemail.bodytext': 'captureemail.bodytext',
  'efcregistrationwidget.jobapplication.captureemail.smalltext': 'captureemail.smalltext',
  'efcregistrationwidget.jobapplication.login.title': 'login.title',
  'efcregistrationwidget.jobapplication.login.bodytext': 'login.bodytext',
  'efcregistrationwidget.jobapplication.login.smalltext': 'login.smalltext',
  'efcregistrationwidget.jobapplication.redirectmessage.title': 'redirectmessage.title',
  'efcregistrationwidget.jobapplication.redirectmessage.bodytext': 'redirectmessage.bodytext',
  'efcregistrationwidget.jobapplication.redirectmessage.smalltext': 'redirectmessage.smalltext',
  'efcregistrationwidget.jobapplication.redirectmessage.continue': 'redirectmessage.continue'
};

const SAVEJOBSEARCH_MAP = {
  'efcregistrationwidget.savejobsearch.captureemail.title': 'captureemail.title',
  'efcregistrationwidget.savejobsearch.captureemail.bodytext': 'captureemail.bodytext',
  'efcregistrationwidget.savejobsearch.captureemail.smalltext': 'captureemail.smalltext',
  'efcregistrationwidget.savejobsearch.login.title': 'login.title',
  'efcregistrationwidget.savejobsearch.login.bodytext': 'login.bodytext',
  'efcregistrationwidget.savejobsearch.login.smalltext': 'login.smalltext'
};

const SAVEJOB_MAP = {
  'efcregistrationwidget.savejob.captureemail.title': 'captureemail.title',
  'efcregistrationwidget.savejob.captureemail.bodytext': 'captureemail.bodytext',
  'efcregistrationwidget.savejob.captureemail.smalltext': 'captureemail.smalltext',
  'efcregistrationwidget.savejob.login.title': 'login.title',
  'efcregistrationwidget.savejob.login.bodytext': 'login.bodytext',
  'efcregistrationwidget.savejob.login.smalltext': 'login.smalltext'
};

const GENERIC_MAP = {
  'efcregistrationwidget.generic.form.email.label': 'form.email.label',
  'efcregistrationwidget.generic.form.password.label': 'form.password.label',
  'efcregistrationwidget.generic.form.forgotpassword.label': 'form.forgotpassword.label',
  'efcregistrationwidget.generic.actions.submit': 'actions.submit',
  'efcregistrationwidget.generic.actions.close': 'actions.close',
  'efcregistrationwidget.generic.verifymessage.title': 'verifymessage.title',
  'efcregistrationwidget.generic.verifymessage.bodytext': 'verifymessage.bodytext',
  'efcregistrationwidget.generic.blockedmessage.title': 'blockedmessage.title',
  'efcregistrationwidget.generic.blockedmessage.bodytext': 'blockedmessage.bodytext',
  'efcregistrationwidget.generic.lockedmessage.title': 'lockedmessage.title',
  'efcregistrationwidget.generic.lockedmessage.bodytext': 'lockedmessage.bodytext',
  'efcregistrationwidget.generic.resetpasswordmessage.title': 'resetpasswordmessage.title',
  'efcregistrationwidget.generic.resetpasswordmessage.bodytext': 'resetpasswordmessage.bodytext',
  'efcregistrationwidget.generic.error.invalidcredentials': 'error.invalidcredentials',
  'efcregistrationwidget.generic.error.networkfailure': 'generic.error.networkfailure',
  'efcregistrationwidget.generic.error.90001': 'error.90001',
  'efcregistrationwidget.generic.error.90002': 'error.90002',
  'efcregistrationwidget.generic.error.90003': 'error.90003',
  'efcregistrationwidget.generic.error.90004': 'error.90004',
  'efcregistrationwidget.generic.error.90110': 'error.90110',
  'efcregistrationwidget.generic.error.90111': 'error.90111',
  'efcregistrationwidget.generic.error.90112': 'error.90112',
  'efcregistrationwidget.generic.error.90113': 'error.90113',
  'efcregistrationwidget.generic.error.90114': 'error.90114',
  'efcregistrationwidget.generic.error.90117': 'error.90117',
  'efcregistrationwidget.generic.error.90118': 'error.90118',
  'efcregistrationwidget.generic.error.90119': 'error.90119'
};

class TranslationMapper {

  constructor(context) {

    this.contextMap = Object.assign({}, GENERIC_MAP, getContextMap(context));


  }

  getTranslationIds() {

    return Object.keys(this.contextMap);

  }

  getMapValue(translationId) {

    return this.contextMap[translationId];

  }

}

function getContextMap(context) {

  let contextMap;
  switch (context) {
    case 'job application':
      contextMap = JOBAPPLICATION_MAP;
      break;
    case 'save job search':
      contextMap = SAVEJOBSEARCH_MAP;
      break;
    case 'save job':
      contextMap = SAVEJOB_MAP;
      break;
    default:
      contextMap = {};
  }

  return contextMap;

}

export default TranslationMapper;



// WEBPACK FOOTER //
// ./src/library/services/TranslationMapper.js